<template>
  <el-dialog
    title="页面模版上传"
    :visible="dialogFormVisible"
    :modal="false"
    custom-class="collectDialog"
    @close="closeDialog"
  >
    <div class="mt16 verticallyCenter">
      <span class="w74 mr16">页面名称</span>
      <el-input class="flex1" v-model="systemPageTemplateForm.name" placeholder="请输入名称"></el-input>
    </div>
    <div class="mt16 verticallyCenter">
      <cx-select
        style="width: 100%"
        title="页面分类"
        :selectOptions="systemPageTypeOptions"
        :value.sync="systemPageType"
      />
    </div>
    <div class="mt16 verticallyTop">
      <span class="w74 mr16">上传封面</span>
      <img-upload
        class="flex1"
        :imgSrc.sync="systemPageTemplateForm.cover"
        :noImgLib="false"
        :imgSize="200 + '*' + 220"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" @click="saveSystemPageTemplateEv">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Qs from "qs"
import { encryption, findAllRects, findAllComponentsInTitleOptions } from "utils"
import { buildModel } from "utils/buildModel.js"
import { data_dictionary_map } from "root/static/dataDictionary"
export default {
  name: "addPageTemplateDialog",
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "list"
    },
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      systemPageTemplateForm: {
        name: "",
        cover: "",
        encId: ""
      },
      isAdmin: false,
      systemPageTypeOptions: [],
      systemPageType: []
    }
  },
  created() {
    this.isAdmin = this.$store.state.states.managerType === 1 ? true : false
  },
  mounted() {},
  watch: {
    dialogFormVisible(n, o) {
      if (n) {
        this.getSystemPageType()
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
      this.systemPageType = ""
    },
    /**
     * 1、清理头底布局数据
     * 2、清理头底中的组件数据
     * 3、列表页需要清理自由布局内容的appId、moduleId、myFetchParam、noCacheComponent
     * 4、页面数据加密
     * 5、组装接口参数
     */
    saveSystemPageTemplateEv() {
      let encId = ""
      const result = this.getContent()
      const content = result.result
      encId = result.encId
      let appContent = {}
      let isNeedAppStyle = sessionStorage.getItem("mobileSubPageStyleToPc")
      if (isNeedAppStyle && this.request_prefix === "stage") {
        sessionStorage.removeItem("mobileSubPageStyleToPc")
        appContent = this.getContent("appStage").result
      }

      const _self = this
      const param = {
        c: content, //页面数据
        t2: this.systemPageType ? this.systemPageType : encId, //类型
        t: this.systemPageTemplateForm.name, //名字
        c2: this.systemPageTemplateForm.cover, //封面
        c3: appContent, // app端页面数据
        ma: true, // 传了该参数后可以不用传appId
        ct: 1    //传0表示收藏的content为组件类型，传1表示content是webJson，不传默认是0, 子页面收藏时传1
      }
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      param.w = websiteId
      param.p = pageId
      if (this.isCollect && this.systemPageType) {
        // 产品提出收藏模版必须上传封面
        if (!this.systemPageTemplateForm.cover) {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "请上传封面！",
            type: "warning"
          })
          return
        }
        //只是自己收藏 添加此参数
        param.coll = true
      }
      _self.$API
        .createSystemComponentAppClone({
          param: param
        })
        .then(res => {
          if (res?.data?.data?.moduleId) {
            _self.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "success",
              // message: res.data.message
              message: '已添加到"我的收藏"'
            })
            _self.closeDialog()
            _self.systemPageTemplateForm.name = ""
            _self.systemPageTemplateForm.cover = ""
          }
        })
        .catch(err => {})
    },
    GetRequest() {
      var url = location.href //获取url中"?"符后的字串
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    // 如果没有传入terminal参数，则默认为当前页面的终端类型，如果传入了terminal参数，则为传入的终端类型
    getContent(terminal) {
      const isNavComponent = window.localStorage.getItem("isNavComponent")
      // 1、清理头底布局数据、清理头底中的组件数据
      const type = terminal ? terminal : this.request_prefix
      let pageOpt = JSON.parse(JSON.stringify(this.$store.state[type].page))
      let encId
      const isSearchComponent = pageOpt.pluginName?.includes("searchListPagePlugin")
      const isGroupSearchComponent = pageOpt.pluginName?.includes("groupSearchListPagePlugin")
      let searchList = [] // 站内检索列表页，聚合检索列表页
      // 2、列表页需要清理自由布局内容的appId、moduleId、myFetchParam、noCacheComponent，还有多级分类导航的value
      const pageType = this.$store.state[type].type
      const menuType = type === "stage" ? "menu" : "appMenu"
      const listPageTypeName = type === "stage" ? "列表页模板" : "移动端列表页模板"
      const detailPageTypeName = type === "stage" ? "详情页模板" : "移动端详情页模板"

      if (pageType === "listPage") {
        encId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === listPageTypeName)[0].encId
        if (isNavComponent) {
          const firstLevelName = type === "stage" ? "导航列表页" : "移动端导航列表页"
          encId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0].encId
        }
        if (isSearchComponent) {
          const firstLevelName = type === "stage" ? "搜索列表页" : "移动端搜索列表页"
          searchList = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]?.subs
          const subLevelName = type === "stage" ? "站内检索列表页" : "移动端站内检索列表页"
          encId = searchList?.filter(item => item.name === subLevelName)[0].encId
        }
        if (isGroupSearchComponent) {
          console.log("type>", type)
          const firstLevelName = type === "stage" ? "搜索列表页" : "移动端搜索列表页"
          console.log("firstLevelName", firstLevelName)
          searchList = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]?.subs
          const subLevelName = type === "stage" ? "聚合检索列表页" : "移动端聚合检索列表页"
          encId = searchList?.filter(item => item.name === subLevelName)[0].encId
        }
        pageOpt.children[0].children.forEach(item => {
          if (item.options.inDocument === "free") {
            item.options.appId = ""
            item.options.moduleId = ""
            item.options.myFetchParam = ""
            item.options.noCacheComponent = false
          }
        //  笔记编辑器的内容清空，避免保存数据过大
          if (item.shape === "cxNoteEditor") {
            item.options.content = ""
          }
        //  列表页右侧自由布局不同样式会保存数据巨大的 storeOptions，需要清除
          if (item.shape === "emptyLayoutComponent" && item.hasOwnProperty("storeOptions")) {
            delete item.storeOptions
          }
        })
        // pageOpt.appIdList = []
        // pageOpt.children[0].children[0].options.noCacheComponent = false
        // pageOpt.children[0].children[0].options.appId = ""
        // pageOpt.children[0].children[0].options.moduleId = ""
        // pageOpt.children[0].children[0].options.myFetchParam = {}

        // 找到当前自由布局中的多级分类导航组件,上传的时候需要将value置为空
        // const AllOtherComponents = findAllComponentsInTitleOptions(pageOpt.children[0].children[0])
        // const navMenuVerticalComponent = AllOtherComponents.filter(item => {
        //   return item.type === "navMenuVertical"
        // })[0]
        // pageOpt.children[0].children[0].options.titleOptions[
        //   navMenuVerticalComponent.directionIndex
        // ].elementOptions.find(
        //   item => item.elementInLayoutId === navMenuVerticalComponent.elementInLayoutId
        // ).options.value = ""
      }
      if (pageType === "detailPage") {
        encId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === detailPageTypeName)[0].encId
      }

      //  当前页面模版类型encId（列表页、详情页）
      if (pageOpt && pageOpt.pageLayoutList && pageOpt.pageLayoutList.length > 0) {
        const length = pageOpt.pageLayoutList.length
        for (let i = 0, flag = true; i < length; flag ? i++ : i) {
          const item = pageOpt.pageLayoutList[i]
          // 清理当前头底的同时，也需要清理头底中的组件
          if (!item) break
          if (item.options.inDocument === "header" || item.options.inDocument === "footer") {
            pageOpt.pageLayoutList.splice(i, 1)
            flag = false
            const oldRectIds = findAllRects(item)
            oldRectIds.forEach(rectId => {
              const index = pageOpt.children[0].children.findIndex(child => child.rect_id === rectId)
              if (index > -1) {
                pageOpt.children[0].children.splice(index, 1)
              }
            })
          } else {
            flag = true
          }
        }
      }
      const pcWidth = 192
      const appWidth = 41.4
      if (type === "stage") {
        buildModel(pageOpt, pcWidth)
      } else {
        buildModel(pageOpt, appWidth)
      }
      // 4、页面数据加密
      pageOpt = encryption(pageOpt, data_dictionary_map)

      //  5、组装接口参数
      if (this.systemPageTemplateForm.name === null) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
        return
      }
      console.log("encId>>>>>", encId)
      return { encId: encId, result: pageOpt, searchList: searchList }
    },
    getSystemPageType() {
      console.log("========getSystemPageType========")
      const result = this.getContent()
      const encId = result.encId
      const menuType = this.request_prefix === "stage" ? "menu" : "appMenu"
      let pageTypes = []
      if (encId) {
        if (result.searchList && result.searchList.length > 0) {
          pageTypes = result.searchList.filter(item => item.encId === encId)
        } else {
          pageTypes = this.$store.state[menuType].menu.otherTypes.filter(item => item.encId === encId)
        }
        let list = []
        if (pageTypes && pageTypes.length > 0) {
          if (pageTypes[0].subs && pageTypes[0].subs.length > 0) {
            pageTypes[0].subs.forEach(item => {
              if (this.isCollect) {
                if (item.name.indexOf("我的") > -1) {
                  list.push({
                    label: item.name,
                    value: item.encId
                  })
                  this.systemPageType = item.encId
                }
              } else {
                if (item.name.indexOf("我的") === -1) {
                  list.push({
                    label: item.name,
                    value: item.encId
                  })
                }
              }
            })
          } else {
            list.push({
              label: pageTypes[0].name,
              value: pageTypes[0].encId
            })
            this.systemPageType = pageTypes[0].encId
          }
          this.systemPageTypeOptions = list
        }
      }
    }
  }
}
</script>
